module.exports = __webpack_public_path__ + "img/frame (144).7cbac9a0.jpg";